import { ANALYSIS } from "../constants";

const initialState = {
    analysis: null,
    analyses: [],
    isLoadingAnalyses: false,
    createdAnalysis: false,
    updatedAnalysis: false,
    isLoadingAnalysis: false,
    error: null,
};

const analysisReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case ANALYSIS.ANALYSIS_GET_ALL:
            return {
                ...state,
                isLoadingAnalyses: true,
                error: null,
            };
        case ANALYSIS.ANALYSIS_GET_ALL_FAILURE:
            return {
                ...state,
                isLoadingAnalyses: false,
                error: action.payload,
            };
        case ANALYSIS.ANALYSIS_GET_ALL_SUCCESS:
            return {
                ...state,
                isLoadingAnalyses: false,
                analyses: action.payload,
                error: null,
            };
        case ANALYSIS.ANALYSIS_CREATE:
            return {
                ...state,
                createdAnalysis: false,
                isLoadingAnalysis: true,
            };
        case ANALYSIS.ANALYSIS_CREATE_FAILURE:
            return {
                ...state,
                isLoadingAnalysis: false,
                error: action.payload,
            };
        case ANALYSIS.ANALYSIS_CREATE_SUCCESS:
            return {
                ...state,
                createdAnalysis: true,
                isLoadingAnalysis: false,
                analysis: action.payload,
                error: null,
            };
        case ANALYSIS.ANALYSIS_UPDATE:
            return {
                ...state,
                updatedAnalysis: false,
                isLoadingAnalysis: true,
            };
        case ANALYSIS.ANALYSIS_UPDATE_FAILURE:
            return {
                ...state,
                isLoadingAnalysis: false,
                error: action.payload,
            };
        case ANALYSIS.ANALYSIS_UPDATE_SUCCESS:
            return {
                ...state,
                updatedAnalysis: true,
                isLoadingAnalysis: false,
                analysis: action.payload,
                error: null,
            };
        case ANALYSIS.ANALYSIS_DELETE:
            return {
                ...state,
                isLoadingAnalysis: true,
            };
        case ANALYSIS.ANALYSIS_DELETE_FAILURE:
            return {
                ...state,
                isLoadingAnalysis: false,
                error: action.payload,
            };
        case ANALYSIS.ANALYSIS_DELETE_SUCCESS:
            return {
                ...state,
                isLoadingAnalysis: false,
                analysis: null,
                error: null,
            };
        case ANALYSIS.ANALYSIS_GET_ONE:
            return {
                ...state,
                isLoadingAnalysis: true,
            };
        case ANALYSIS.ANALYSIS_GET_ONE_FAILURE:
            return {
                ...state,
                isLoadingAnalysis: false,
                error: action.payload,
            };
        case ANALYSIS.ANALYSIS_GET_ONE_SUCCESS:
            return {
                ...state,
                isLoadingAnalysis: false,
                analysis: action.payload,
                error: null,
            };
        default:
            return state;
    }
};

export default analysisReducer;